export default defineNuxtPlugin(() => {

  if (!('serviceWorker' in navigator)) {

    return;
  
  }

  window.addEventListener('load', () => {

    navigator.serviceWorker.register('/workers/bloomreach.js').catch(() => undefined);
  
  });

});
